import { render, staticRenderFns } from "./firstStep.vue?vue&type=template&id=404f70b0&scoped=true"
import script from "./firstStep.vue?vue&type=script&lang=ts"
export * from "./firstStep.vue?vue&type=script&lang=ts"
import style0 from "./firstStep.vue?vue&type=style&index=0&id=404f70b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f70b0",
  null
  
)

export default component.exports